import createCache, { type EmotionCache } from '@emotion/cache';

const LINARIA_OVERRIDE = ':not(#\\#)';

export const prioritizeEmotionOverLinaria = (cache: EmotionCache): EmotionCache => {
  const emotionClassPrefix = `.${cache.key}-`;
  const insert = cache.insert.bind(cache);
  cache.insert = (selector, serialized, sheet, shouldCache) =>
    insert(
      selector.startsWith(emotionClassPrefix) ? `${selector}${LINARIA_OVERRIDE}` : selector,
      serialized,
      sheet,
      shouldCache
    );
  return cache;
};

export const createPrioritizedEmotionCache = (key: string): EmotionCache => {
  const cache = prioritizeEmotionOverLinaria(createCache({ key }));
  cache.compat = true;
  return cache;
};
